import React, { Component } from "react";
import { Button } from "carbon-components-react";
import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";

import { importService } from "../../_services/import.services";
import { notifySuccess } from "./notification/NotificationHelper";
import Spinner from "./spinner/Spinner";

const INDICATORS = [
  { key: "sdg1633", label: "SDG 16.3.3", enabled: true },
  { key: "sdg1671b", label: "SDG 16.7.1b", enabled: true },
  { key: "sdg1662", label: "SDG 16.6.2 (coming soon)", enabled: false },
  { key: "sdg1671c", label: "SDG 16.7.1c (coming soon)", enabled: false },
  { key: "sdg1672", label: "SDG 16.7.2 (coming soon)", enabled: false }
];

class DataImport extends Component {
  state = { indicator: "", file: null, preview: null, loading: false };

  fileInput = React.createRef();

  onIndicatorChange = e => {
    this.reset({ indicator: e.target.value });
  };

  onFileChange = e => {
    const file = e.target.files[0] || null;
    this.setState({ file, preview: null });
    if (file) {
      this.send(file, true);
    }
  };

  send(file, dryRun) {
    const { indicator } = this.state;
    this.setState({ loading: true });
    importService.importFile(indicator, file, dryRun).then(result => {
      if (result && !dryRun) {
        notifySuccess(
          result.created +
            " records created, " +
            result.updated +
            " filled in, " +
            result.skipped.length +
            " skipped (data already exists)."
        );
        this.reset({ indicator });
      } else {
        this.setState({ loading: false, preview: result });
      }
    });
  }

  reset(state) {
    if (this.fileInput.current) {
      this.fileInput.current.value = "";
    }
    this.setState({ file: null, preview: null, loading: false, ...state });
  }

  renderPreview() {
    const { indicator, preview } = this.state;
    if (!preview) {
      return null;
    }
    const label = INDICATORS.find(i => i.key === indicator).label;
    return (
      <div style={{ marginTop: "2rem" }}>
        <h4>
          Importing into {label} – years {preview.years.join(", ") || "none"}
        </h4>
        <p>
          {preview.created} records to create, {preview.updated} existing empty
          records to fill in, {preview.skipped.length} skipped because data
          already exists, {preview.errors.length} rows with errors (ignored).
        </p>
        {preview.skipped.length > 0 && (
          <React.Fragment>
            <h5>Skipped – data already exists</h5>
            <table className="bx--data-table">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {preview.skipped.map((item, i) => (
                  <tr key={i}>
                    <td>{item.row}</td>
                    <td>{item.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </React.Fragment>
        )}
        {preview.errors.length > 0 && <h5>Errors</h5>}
        {preview.errors.length > 0 && (
          <table className="bx--data-table">
            <thead>
              <tr>
                <th>Row</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {preview.errors.map((error, i) => (
                <tr key={i}>
                  <td>{error.row}</td>
                  <td>{error.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Button
          style={{ marginTop: "1rem" }}
          disabled={preview.created + preview.updated === 0}
          onClick={() => this.send(this.state.file, false)}
        >
          Confirm import
        </Button>
      </div>
    );
  }

  render() {
    const { indicator, loading } = this.state;
    return (
      <div className="bx--grid">
        <h2>Import data from Excel</h2>
        <div style={{ maxWidth: "24rem", margin: "1.5rem 0" }}>
          <Select
            id="import-indicator"
            labelText="Indicator"
            value={indicator}
            onChange={this.onIndicatorChange}
          >
            <SelectItem value="" text="Select an indicator" />
            {INDICATORS.map(i => (
              <SelectItem
                key={i.key}
                value={i.key}
                text={i.label}
                disabled={!i.enabled}
              />
            ))}
          </Select>
        </div>
        <div>
          <Button
            kind="secondary"
            disabled={!indicator}
            onClick={() => importService.downloadTemplate(indicator)}
          >
            Download template
          </Button>
        </div>
        <div style={{ marginTop: "1.5rem" }}>
          <input
            type="file"
            accept=".xlsx"
            ref={this.fileInput}
            disabled={!indicator || loading}
            onChange={this.onFileChange}
          />
        </div>
        {loading && <Spinner />}
        {this.renderPreview()}
      </div>
    );
  }
}

export default DataImport;
